__turbopack_context__.v({
  "card": "LxU9hW_card",
  "label": "LxU9hW_label",
  "meta": "LxU9hW_meta",
  "reference": "LxU9hW_reference",
  "referenceMuted": "LxU9hW_referenceMuted",
});
